import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import { SiteAlarmOption, siteAlarmOptionSchema } from '@sophocles/entities/SiteAlarmOption/siteAlarmOptionRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_SITE_ALARM_OPTIONS = 'RECEIVE_SITE_ALARM_OPTIONS';
function receiveSiteAlarmOptions(json) {
  return {
    type: RECEIVE_SITE_ALARM_OPTIONS,
    siteAlarmOptions: mapListToRecords(json, SiteAlarmOption),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SITE_ALARM_OPTION = 'REQUEST_SITE_ALARM_OPTION';
function requestSiteAlarmOption(siteAlarmOption_id) {
  return {
    type: REQUEST_SITE_ALARM_OPTION,
    siteAlarmOption_id,
  };
}

export const REQUEST_SITE_ALARM_OPTIONS_FOR_SITE = 'REQUEST_SITE_ALARM_OPTIONS_FOR_SITE';
function requestSiteAlarmOptionsForSite(site) {
  return {
    type: REQUEST_SITE_ALARM_OPTIONS_FOR_SITE,
    site,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSiteAlarmOption(siteAlarmOption_id) {
  return dispatch => {
    dispatch(requestSiteAlarmOption(siteAlarmOption_id));
    return apiClient
      .get(`/sitealarmoptions/${siteAlarmOption_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'siteAlarmOptions', siteAlarmOptionSchema))
      .then(json => dispatch(receiveSiteAlarmOptions(json.entities.siteAlarmOptions)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_SITE_ALARM_OPTION));
      });
  };
}

export function fetchSiteAlarmOptionsForSite(site_id) {
  return dispatch => {
    dispatch(requestSiteAlarmOptionsForSite(site_id));
    return apiClient
      .get(`/sitealarmoptions/?site=${site_id}&limit=1000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'siteAlarmOptions', siteAlarmOptionSchema))
      .then(json => dispatch(receiveSiteAlarmOptions(json.entities.siteAlarmOptions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_ALARM_OPTIONS_FOR_SITE)));
  };
}

/* Edit Actions */
export const EDIT_SITE_ALARM_OPTION = 'EDIT_SITE_ALARM_OPTION';
export function editSiteAlarmOption(siteAlarmOption_id) {
  return {
    type: EDIT_SITE_ALARM_OPTION,
    siteAlarmOption: siteAlarmOption_id,
  };
}

export function patchSiteAlarmOption(siteAlarmOption_id, values) {
  return dispatch => {
    dispatch(editSiteAlarmOption(siteAlarmOption_id));
    return apiClient
      .patch(`/sitealarmoptions/${siteAlarmOption_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteAlarmOptionSchema))
      .then(json => {
        dispatch(receiveSiteAlarmOptions(json.entities.siteAlarmOptions));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_SITE_ALARM_OPTION));
      });
  };
}

export const BATCH_EDIT_SITE_ALARM_OPTIONS = 'BATCH_EDIT_SITE_ALARM_OPTIONS';
export function batchEditSiteAlarmOptions(siteAlarmOptions) {
  return {
    type: BATCH_EDIT_SITE_ALARM_OPTIONS,
    siteAlarmOptions,
  };
}

export function bulkPatchSiteAlarmOptions(values, ignoreOnly = false) {
  let url = '/sitealarmoptions/batchupdate/?limit=1000';
  if (ignoreOnly) {
    url += '&ignore_enabled_only=true';
  }
  return dispatch => {
    dispatch(batchEditSiteAlarmOptions(values));
    return apiClient
      .post(url, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Update',
            message: 'Alarm options updated successfully',
            level: 'success',
            dismissible: true,
          }),
        );
      })
      .catch(error => {
        dispatch(
          addToast({
            title: 'Error',
            message: 'An error has occurred, settings were not saved.',
            level: 'error',
            dismissible: true,
          }),
        );
        return dispatch(genericErrorAction(error, EDIT_SITE_ALARM_OPTION));
      });
  };
}

/* Create Actions */
export const CREATE_SITE_ALARM_OPTION = 'CREATE_SITE_ALARM_OPTION';
function sayCreateSiteAlarmOption(values) {
  return {
    type: CREATE_SITE_ALARM_OPTION,
    values: values,
  };
}

export function createSiteAlarmOption(values) {
  return dispatch => {
    dispatch(sayCreateSiteAlarmOption(values));
    return apiClient
      .post(`/sitealarmoptions/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteAlarmOptionSchema))
      .then(json => {
        dispatch(receiveSiteAlarmOptions(json.entities.siteAlarmOptions));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_SITE_ALARM_OPTION));
      });
  };
}

/* Delete Actions */
export const DELETE_SITE_ALARM_OPTION = 'DELETE_SITE_ALARM_OPTION';
function sayDeleteSiteAlarmOption(siteAlarmOption_id) {
  return {
    type: DELETE_SITE_ALARM_OPTION,
    siteAlarmOption: siteAlarmOption_id,
  };
}

export function deleteSiteAlarmOption(siteAlarmOption_id) {
  return dispatch =>
    apiClient
      .delete(`/sitealarmoptions/${siteAlarmOption_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSiteAlarmOption(siteAlarmOption_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_SITE_ALARM_OPTION));
      });
}

const receiver = (dispatch, json) => dispatch(receiveSiteAlarmOptions(json.entities.siteAlarmOptions));

export const handleSiteAlarmOptionSocketActions = websocketsHandlerFactory(
  receiver,
  sayDeleteSiteAlarmOption,
  SiteAlarmOption,
);
